import React, { memo, useMemo } from 'react';
import MultiSelectDropdown from '../../../Common/MultiSelectDropdown';
import { getMetricsOptions } from '../../FormUtils';

const EvaluationSection = memo(({
  formData,
  setFormData,
  isEditing = true
}) => {
  const metricsOptions = useMemo(() =>
    getMetricsOptions(formData.modeling_type),
    [formData.modeling_type]
  );

  const handleMetricsChange = (selectedValues) => {
    setFormData({
      ...formData,
      evaluation_metrics: {
        ...formData.evaluation_metrics,
        evaluation_metrics_list: selectedValues
      }
    });
  };

  const handleTopNChange = (selectedValues) => {
    setFormData({
      ...formData,
      evaluation_metrics: {
        ...formData.evaluation_metrics,
        top_n: selectedValues
      }
    });
  };

  return (
    <div className="bg-white rounded-lg shadow p-4 lg:p-6">
      <h2 className="text-lg font-semibold mb-4">Evaluation</h2>

      <div className="flex flex-col gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Metrics</label>
          <MultiSelectDropdown
            options={metricsOptions}
            selectedValues={formData.evaluation_metrics?.evaluation_metrics_list || []}
            onChange={handleMetricsChange}
            placeholder="Select evaluation metrics..."
            isEditing={isEditing}
          />
        </div>

        {formData.modeling_type?.type === 'multi-class' && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Top N</label>
            <input
              type="number"
              className="w-full border rounded px-3 py-2 bg-white pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              value={formData.evaluation_metrics?.top_n || 1}
              onChange={(e) => handleTopNChange(e.target.value)}
              disabled={!isEditing}
            />
          </div>
        )}
      </div>
    </div>
  );
});

EvaluationSection.displayName = 'EvaluationSection';

export default EvaluationSection;
